<template>
	<div class="cartInfoWrapper">
		<div>
			<div class="new-order-button" @click="newOrder" v-if="displayNewOrderButton()">
				<span>+ New Order</span>
			</div>

			<div class="orderDetailsBox3B" v-if="customer && customer.card_number">
				<div class="infoLabel">Member</div>
				<div class="orderDetailText">
					{{ customer.card_number }}
				</div>
				<div class="trashIcon">
					<span @click="removeCustomer">
						<ios-close-icon w="24px" h="24px" />
					</span>
				</div>
			</div>

			<div class="orderDetailsBox3B" v-if="order.salesperson">
				<div class="infoLabel">Sales</div>
				<div class="orderDetailText">
					<div>{{ order.salesperson.name }}</div>
				</div>
				<div class="trashIcon">
					<span @click="removeSalesperson">
						<ios-close-icon w="24px" h="24px" />
					</span>
				</div>
			</div>

			<div class="paymentOptions">
				<div class="paymentOption" v-bind:class="paymentClass(1)" @click="infoChangePaymentType(1)">CASH</div>
				<div class="paymentOption" v-bind:class="paymentClass(2)" @click="infoChangePaymentType(2)">CARD</div>
			</div>

			<div class="paymentOptions">
				<div class="paymentOption" v-bind:class="paymentClass(3)" @click="infoChangePaymentType(3)">POINTS</div>
				<div class="paymentOption" v-bind:class="paymentClass(4)" @click="infoChangePaymentType(4)">COUPON</div>
			</div>

			<div class="coupons" v-if="openCoupon">
				<p class="couponLabel">Coupons</p>
				<div class="couponItemWrapper" v-for="(item, index) of coupons" v-bind:key="index">
					<div class="infoLabel">{{ item.name }}</div>
					<div class="couponAmount">{{ item.amount }}</div>
					<div class="trashIcon">
						<span @click="removeCoupon(index)">
							<ios-close-icon w="24px" h="24px" />
						</span>
					</div>
				</div>

				<div class="couponInputWrapper" v-if="brands">
					<b-autocomplete
						v-model="brandSuggestions"
						:data="filteredBrands"
						:open-on-focus="true"
						placeholder="Brand"
						field="name"
						@select="option => (brandSelection = option)"
						class="brandAutocomplete"
					>
						<template slot="empty">No results found</template>
					</b-autocomplete>

					<input
						name="couponAmount"
						class="couponInput"
						placeholder="Enter Amount"
						v-model="couponAmount"
						v-on:keyup.enter="addCoupon"
						autocomplete="off"
					/>
				</div>
			</div>

			<div class="orderDetailsBox" v-if="order.no_promotion_total_price">
				<div class="priceInfoLabel">Original Price</div>
				<div class="originalPrice">{{ order.no_promotion_total_price.toLocaleString('en-GB') }}</div>
			</div>

			<div class="orderDetailsBox" v-if="order.no_promotion_total_price">
				<div class="priceInfoLabel">Save</div>
				<div class="originalPrice">{{ calculateSave.toLocaleString('en-GB') }}</div>
			</div>

			<div class="orderDetailsBox" v-if="order.total_price">
				<div class="priceInfoLabel total-price-label">Total Price</div>
				<div class="totalPrice">{{ order.total_price.toLocaleString('en-GB') }}</div>
			</div>

			<div class="customerPaidAmountWrapper">
				<input
					name="customerPaidAmount"
					class="customerPaidAmount textbox-shadow"
					placeholder="Enter Amount"
					v-model="customerPaidAmount"
					v-on:change="addPayAmount"
					autocomplete="off"
				/>
			</div>

			<div class="orderDetailsBox">
				<div class="priceInfoLabel">Change</div>
				<div class="changePrice">{{ changedAmount }}</div>
			</div>

			<div class="orderDescWrapper">
				<textarea
					name="orderDesc"
					class="orderDesc textbox-shadow"
					placeholder="Order Description"
					v-bind:value="order.description"
					v-on:change="updateOrderDesc($event.target.value)"
				/>
			</div>

			<div class="online-sales-wrapper">
				<b-checkbox v-model="onlineSalesCheckbox">
					Online Sales
				</b-checkbox>

				<div v-if="onlineSalesBrand" class="online-sales">
					<div>{{ onlineSalesBrand.name }}</div>
					<div><div @click="addOnlineSales(true)" class="online-sales-remove" v-if="order.pay_status == 0">Remove</div></div>
				</div>

				<div class="couponInputWrapper" v-if="onlineSalesCheckbox && brands && !onlineSalesBrand">
					<b-autocomplete
						v-model="brandSuggestions"
						:data="filteredBrands"
						:open-on-focus="true"
						placeholder="Brand"
						field="name"
						@select="option => (onlineSalesBrand = option)"
						class="brandAutocomplete"
					>
						<template slot="empty">No results found</template>
					</b-autocomplete>
				</div>
			</div>
		</div>

		<div>
			<div class="checkoutButton" @click="checkout" v-bind:class="{ disabled: order.pay_status }">
				<span v-if="order.pay_status == 1 || order.pay_status == 2">Reprint</span>

				<span v-else>Checkout</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['cartDetails', 'paymentType', 'changePaymentType', 'order'],
	data: function() {
		return {
			coupons: [],
			isComponentModalActive: false,
			customerPaidAmount: null,
			changedAmount: null,
			brandSelection: null,
			brandSuggestions: '',
			couponAmount: null,
			onlineSalesCheckbox: false,
			onlineSalesBrand: null,
			brands: null,
			openCoupon: false,
			customer: null,
			salesgirl: {
				name: null,
				id: null
			}
		}
	},
	mounted: async function() {
		if (this.order.pay_amount !== undefined) {
			this.customerPaidAmount = this.order.pay_amount
		}

		if (this.order.online_sales !== undefined) {
			this.onlineSalesCheckbox = true
			this.onlineSalesBrand = this.order.online_sales
		}

		// Get brand list for coupon
		var apiGetBrandList = await this.$api.getBrandList()

		if (apiGetBrandList !== undefined) {
			this.brands = apiGetBrandList.data.list
		}

		// Show or hide coupons
		if (this.order.payment_method) {
			var paymentTypeFound = this.order.payment_method.find(paymentType => {
				return paymentType == 4
			})

			this.openCoupon = paymentTypeFound ? true : false
		}
	},
	computed: {
		filteredBrands() {
			return this.brands.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.brandSuggestions.toLowerCase()) >= 0
				)
			})
		},

		calculateSave() {
			var total = this.order.no_promotion_total_price - this.order.total_price
			if (this.order.coupons.length > 0) {
				this.order.coupons.map(coupon => {
					total = total - coupon.amount
				})

				return total
			} else {
				return total
			}
		}
	},
	watch: {
		onlineSalesBrand: function(newData) {
			if (newData !== null && this.order.pay_status == 0) {
				this.addOnlineSales()
			}
		},

		// Add comma in customer paid amount and calcuate the change
		customerPaidAmount: function(newData) {
			if (newData !== undefined) {
				var cleanAmount = newData || 0

				cleanAmount = String(cleanAmount).replace(/,/g, '')

				var newChangedAmount = cleanAmount - this.order.total_price

				this.$parent.updatePayAmount(cleanAmount)

				if (newChangedAmount > 0 && newChangedAmount !== undefined) {
					this.changedAmount = newChangedAmount.toLocaleString('en-GB')
				} else {
					this.changedAmount = '0'
				}

				this.customerPaidAmount = newData.toLocaleString('en-GB')
			}
		},

		'$store.state.customer': function() {
			this.customer = this.$store.state.customer
		},

		order: {
			immediate: true,
			handler: function() {
				// Calculate change
				var newChangedAmount = this.customerPaidAmount - this.order.total_price

				if (newChangedAmount > 0) {
					this.changedAmount = newChangedAmount
				} else {
					this.changedAmount = '0'
				}

				// Set paid amount value
				this.customerPaidAmount = this.order.pay_amount

				if (this.order.payment_method) {
					// Show or hide coupons
					var paymentTypeFound = this.order.payment_method.find(paymentType => {
						return paymentType == 4
					})

					this.openCoupon = paymentTypeFound ? true : false
				} else {
					this.openCoupon = false
				}

				// Set online sales
				if (this.order.online_sales !== undefined) {
					this.onlineSalesCheckbox = true

					if (this.brands) {
						const brandFilter = this.brands.find(brand => {
							return brand._id == this.order.online_sales
						})
						this.onlineSalesBrand = brandFilter
					}
				} else {
					this.onlineSalesCheckbox = false
					this.onlineSalesBrand = null
				}

				if (this.order.coupons !== undefined) {
					// Reset coupons
					this.coupons = []

					this.order.coupons.map(coupon => {
						this.coupons.push({
							brand: coupon.brand._id,
							name: coupon.brand.name,
							amount: coupon.amount
						})
					})
				}
			}
		}
	},
	methods: {
		displayErrMsg: function() {
			this.$swal.fire({
				icon: 'error',
				title: 'Oops...',
				text: 'This order is not active!'
			})
		},

		// To display new order button or not
		displayNewOrderButton() {
			return true
			// if (this.order.pay_status !== 0) {
			// 	return true
			// }

			// if (this.order && this.order._id) {
			// 	return true
			// } else {
			// 	return false
			// }
		},

		// Add pay_amount to API
		addPayAmount: function() {
			if (this.order.pay_status !== 0) {
				this.displayErrMsg()
				this.customerPaidAmount = null
				return
			}

			var cleanAmount = this.customerPaidAmount || 0

			cleanAmount = String(cleanAmount).replace(/,/g, '')

			this.$parent.addPayAmount(cleanAmount)
		},

		// Add Online Sales to API
		addOnlineSales: function(remove = false) {
			// Remove true will remove the online sales
			if (this.order.pay_status !== 0) {
				this.displayErrMsg()
				this.onlineSales = false
				this.onlineSalesBrand = null
				return
			}

			if (!remove) {
				this.$parent.addOnlineSales(this.onlineSalesBrand._id)
			} else {
				this.$parent.addOnlineSales(null)
			}
		},

		// Add coupon into array
		addCoupon: function() {
			if (this.order.pay_status !== 0) {
				this.displayErrMsg()
				return
			}

			if (this.brandSelection == null || this.couponAmount == null || this.couponAmount == '') {
				this.$buefy.toast.open({
					message: 'Missing Brand or Amount',
					type: 'is-danger',
					position: 'is-top'
				})

				return
			}

			var newData = {
				brand: this.brandSelection._id,
				amount: this.couponAmount,
				name: this.brandSelection.name
			}

			this.coupons.push(newData)

			// Clean up the form
			this.brandSelection = null
			this.brandSuggestions = ''
			this.couponAmount = null

			// Update coupon via API from parent
			this.$parent.updateCoupon(this.coupons)
		},

		// Remove coupon from array
		removeCoupon: function(index) {
			if (this.order.pay_status !== 0) {
				this.displayErrMsg()
				return
			}

			this.coupons.splice(index, 1)

			// Update coupon via API from parent
			this.$parent.updateCoupon(this.coupons)
		},

		// Generate a new order
		newOrder: function() {
			this.coupons = []
			this.$parent.newOrder()
		},

		// Remove sales person from this order
		removeSalesperson: function() {
			if (this.order.pay_status !== 0) {
				this.displayErrMsg()
				return
			}

			this.$parent.closeSuggestion('cancel')
		},

		// Remove customer for this order
		removeCustomer: function() {
			if (this.order.pay_status !== 0) {
				this.displayErrMsg()
				return
			}

			this.$parent.removeCustomer()
		},

		// Checkout process
		checkout: function() {
			if (this.order.pay_status !== 1) {
				// Make sure customer paid amount is more than order total amount
				let cleanAmount = this.customerPaidAmount || 0
				cleanAmount = String(cleanAmount).replace(/,/g, '')

				if (!this.customerPaidAmount || cleanAmount < this.order.total_price) {
					this.$swal.fire('Customer Paid Amount', 'Please check customer paid amount!', 'info')
					return
				}

				this.$parent.prepareCheckout()
			} else {
				this.$parent.checkout()
			}
		},

		// Update Order Desciption
		updateOrderDesc: function(value) {
			if (this.order.pay_status !== 0) {
				this.displayErrMsg()
				return
			}

			this.$parent.changeOrderDesc(value)
		},

		// Change payment type on click
		infoChangePaymentType: function(type) {
			if (this.order.pay_status !== 0) {
				this.displayErrMsg()
				return
			}

			this.$parent.changePaymentType(type)
		},

		// Check active payment type class
		paymentClass: function(type) {
			if (this.order.payment_method) {
				var matchFound = this.order.payment_method.find(paymentType => {
					return paymentType == type
				})

				return matchFound ? 'active' : null
			}
			return null
		}
	}
}
</script>

<style scoped>
@import '../styles/CartInfo.css';
</style>
